import { render, staticRenderFns } from "./NewsTabLinks.vue?vue&type=template&id=83bf15f0&"
import script from "./NewsTabLinks.vue?vue&type=script&lang=js&"
export * from "./NewsTabLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports